import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'bbl-dining-fe';
  isShowBanner = false;

  ngOnInit() {
    this.isShowBanner = sessionStorage.getItem('isShowBanner') === 'true';
  }

  onClickBanner() {
    sessionStorage.setItem('isShowBanner', 'true');
    this.isShowBanner = true;
  }
}
